import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getNominations = async (orderBy = 'votes') => {
  try {
    const response = await api.get('/nominations/', {
      params: {
        order_by: orderBy
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSeasons = async () => {
  try {
    const response = await api.get('/seasons/');
    return response.data;
  } catch (error) {
    throw error;
  }
};